import * as v from 'valibot'
import { SubmitFormEntry } from '@chilipiper/api-client/src/chat-platform-chat'
import { phoneRegExp, removeDotsFromDataFieldPath } from '../helpers'

type ValidationSchema = v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>

export const createValibotSchema = (fields: Array<SubmitFormEntry>) => {
  const schema = fields?.reduce<Record<string, ValidationSchema>>((schema, field) => {
    const validation = getSubmitForValidation(field)
    if (!validation) {
      return schema
    }

    return { ...schema, [removeDotsFromDataFieldPath(field.ref)]: validation }
  }, {})

  return v.object(schema)
}

const getSubmitForValidation = (dataField: SubmitFormEntry) => {
  const label = dataField.fieldLabel ?? 'Field'
  const requiredErrorMessage = `${label} is required`
  const { dataTypeInfo } = dataField

  let fieldSchema: ValidationSchema | undefined

  if (dataTypeInfo.type === 'Email') {
    fieldSchema = v.pipe(v.string(requiredErrorMessage), v.trim(), v.email('This email is invalid'))
  }
  if (dataTypeInfo.type === 'Phone') {
    fieldSchema = v.pipe(
      v.string(requiredErrorMessage),
      v.regex(phoneRegExp, 'This phone is invalid')
    )
  }
  if (dataTypeInfo.type === 'ShortText') {
    fieldSchema = v.pipe(
      v.string(requiredErrorMessage),
      v.maxLength(80, 'Character limit exceeded (max 80)')
    )
  }
  if (dataTypeInfo.type === 'LongText') {
    fieldSchema = v.pipe(
      v.string(requiredErrorMessage),
      v.maxLength(240, 'Character limit exceeded (max 240)')
    )
  }
  if (dataTypeInfo.type === 'Number') {
    fieldSchema = v.pipe(
      v.string(requiredErrorMessage),
      v.transform(value => Number(value.replace(/,/g, ''))),
      v.integer('Only integer values are allowed')
    )
  }

  if (dataTypeInfo.type === 'Picklist') {
    fieldSchema = v.string(requiredErrorMessage)
  }

  return fieldSchema
}
